import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useOptions from "./options";
import { Menu, Sider, MenuWrapper, MobileMenuIcon, SidebarOverlay } from "./Sidebar.style";
import { useMediaQuery } from "../../utils/useMediaQuery";

const Sidebar = () => {
  const navigate = useNavigate();
  const { options, defaultSelectedKeys } = useOptions();
  const [collapsed, setCollapsed] = useState(false);
  const [forcedCollapsed, setForcedCollapsed] = useState(true); // true = hidden on mobile
  const isMobile = useMediaQuery("(max-width: 575px)");
  const handleClicked = (item) => {
    navigate(item.key);
    // On mobile, close sidebar after clicking
    if (isMobile) {
      setForcedCollapsed(true);
    }
  };

  const closeSidebar = () => {
    if (isMobile) {
      setForcedCollapsed(true);
    }
  };

  const toggleSidebar = () => {
    if (forcedCollapsed) {
      setForcedCollapsed(false);
      setCollapsed(false); // Ensure it's in expanded mode when opened
    } else {
      setForcedCollapsed(true);
    }
  };

  return (
    <>
      {/* Mobile Menu Toggle Button (visible only on mobile) */}
      {isMobile && (
        <MobileMenuIcon
          onClick={toggleSidebar}
          style={{ display: forcedCollapsed ? "block" : "none" }}
        />
      )}

      {isMobile && !forcedCollapsed && (
        <SidebarOverlay onClick={closeSidebar} />
      )}


      {/* Sidebar */}
      <Sider
        collapsible
        collapsed={collapsed}
        forcedcollapsed={forcedCollapsed}
        onCollapse={(isCollapsed) => {
          setCollapsed(isCollapsed);
          setForcedCollapsed(true); // Keep it visible after collapse toggle
        }}
        // Close mobile sidebar when clicking outside
        onMouseLeave={() => {
          if (window.innerWidth <= 575 && !forcedCollapsed) {
            setForcedCollapsed(true);
          }
        }}
      >
        <MenuWrapper>
          <Menu
            mode="inline"
            items={options.map((item) => ({
              ...item,
              label:
                collapsed && item.label !== "Dashboard" ? null : item.label, // Hide label when collapsed
              children: item.children?.map((child) => ({
                ...child,
                label: child.label,
              })),
            }))}
            defaultSelectedKeys={defaultSelectedKeys}
            onClick={handleClicked}
            inlineCollapsed={collapsed}
          />
        </MenuWrapper>
      </Sider>
    </>
  );
};

export default Sidebar;
